import * as Yup from "yup";

export const marketplaceFormSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  status: Yup.string().required("Status is required"),
  logo: Yup.array().required("Logo  is required"),
  banner: Yup.array().required("Cover is required")
});
